/**
 * @see https://umijs.org/docs/max/access#access
 * */
type CurrentUserLike = {
  access?: string;
  roles?: string[];
};

export default function access(
  initialState: { currentUser?: CurrentUserLike } | undefined,
) {
  const { currentUser } = initialState ?? {};

  const hasRole = (role: string) => {
    return currentUser?.roles?.includes(role) || currentUser?.access === role;
  };


  const permissions = {
    canAdmin: hasRole('admin'),
    canUser: !!currentUser,
    canReview: hasRole('reviewer') || hasRole('admin'), // reviewer 或 admin 都可以访问
  };

  return permissions;
}
